import { render, staticRenderFns } from "./clientItem.vue?vue&type=template&id=d4fde37e&"
import script from "./clientItem.vue?vue&type=script&lang=js&"
export * from "./clientItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports